import { useCallback, useState } from 'react';

export interface DeviceLocation {
  lat: number;
  lng: number;
  accuracyMeters: number | null;
}

export function useDeviceLocation() {
  const [isCapturing, setIsCapturing] = useState(false);

  const captureLocation = useCallback(() => new Promise<DeviceLocation>((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('This browser does not support geolocation.'));
      return;
    }
    setIsCapturing(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setIsCapturing(false);
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracyMeters: Number.isFinite(position.coords.accuracy) ? position.coords.accuracy : null,
        });
      },
      (error) => {
        setIsCapturing(false);
        reject(new Error(error.message || 'Could not capture your location.'));
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
    );
  }), []);

  return { isCapturing, captureLocation };
}
